import { render, staticRenderFns } from "./SNavButton.vue?vue&type=template&id=52639349&scoped=true&"
import script from "./SNavButton.vue?vue&type=script&lang=js&"
export * from "./SNavButton.vue?vue&type=script&lang=js&"
import style0 from "./SNavButton.vue?vue&type=style&index=0&id=52639349&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52639349",
  null
  
)

export default component.exports